{
  "approve": "Approve",
  "emailConfirmed": "Email confirmed",
  "emailNotConfirmed": "Email not confirmed",
  "registeredAt": "registered {{time}}",
  "reject": "Reject"
}
